import React from 'react';
import { clientFieldFocusStyles, fontSans, headerButtonStyle, pageGutter, warmHeaderBg } from './requestChangesStyles';

export default function RequestChangesModeHeader({
  onCancel,
  utility = null,
  subtitle = 'Adjust quantities, remove items, or add a product.',
  actionLabel = 'Cancel'
}) {
  return (
    <div
      className="no-print request-changes-header-bar"
      style={{
        width: '100%',
        backgroundColor: warmHeaderBg,
        borderBottom: '1px solid #e8e0d4'
      }}
    >
      <style>{`
        ${clientFieldFocusStyles}
        .request-changes-header-actions button:focus-visible,
        .request-changes-editing-rail button:focus-visible,
        .request-changes-sticky-bar button:focus-visible,
        .request-another-product button:focus-visible,
        .request-add-product-modal button:focus-visible {
          outline: 2px solid #2C2C2C;
          outline-offset: 2px;
        }
        .request-changes-editing-rail button:focus-visible {
          outline-color: #fff;
        }
        @media screen and (min-width: 769px) and (max-width: 1024px) {
          [data-client-shareable-link="true"] .request-changes-header-inner,
          [data-client-shareable-link="true"] .request-changes-sticky-inner {
            padding-left: 24px !important;
            padding-right: 24px !important;
          }
        }
        @media screen and (max-width: 768px) {
          [data-client-shareable-link="true"] .request-changes-header-inner,
          [data-client-shareable-link="true"] .request-changes-sticky-inner {
            padding-left: 16px !important;
            padding-right: 16px !important;
          }
          .request-changes-header-inner {
            flex-wrap: wrap !important;
            align-items: flex-start !important;
            gap: 12px !important;
          }
          .request-changes-header-right {
            width: 100%;
            flex-wrap: wrap !important;
            justify-content: space-between !important;
            gap: 12px !important;
          }
          .request-changes-header-actions {
            margin-left: auto;
            width: auto !important;
            flex: 0 0 auto !important;
          }
          .request-changes-header-actions button {
            width: auto !important;
            flex: 0 0 auto !important;
            height: 36px !important;
            padding: 8px 12px !important;
          }
        }
      `}</style>
      <div
        className="request-changes-header-inner"
        style={{
          width: '100%',
          boxSizing: 'border-box',
          padding: `12px ${pageGutter}px`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 24
        }}
      >
        <div className="request-changes-header-copy" style={{ minWidth: 0, flex: '1 1 auto' }}>
          <div style={{
            fontFamily: fontSans,
            fontSize: 12,
            fontWeight: 600,
            color: '#2C2C2C',
            letterSpacing: '0.12em',
            textTransform: 'uppercase',
            lineHeight: 1.2
          }}>
            Request Changes
          </div>
          {subtitle ? (
            <p style={{
              margin: '5px 0 0',
              fontFamily: fontSans,
              fontSize: 13,
              color: '#6b645c',
              lineHeight: 1.4
            }}>
              {subtitle}
            </p>
          ) : null}
        </div>
        <div className="request-changes-header-right" style={{ display: 'flex', alignItems: 'center', gap: 22, flexShrink: 0 }}>
          {utility ? (
            <>
              <div className="request-changes-header-utility" style={{ opacity: 0.75, paddingRight: 4 }}>
                {utility}
              </div>
              <span aria-hidden="true" style={{ width: 1, height: 22, backgroundColor: '#d8d0c4', margin: '0 2px' }} />
            </>
          ) : null}
          <div className="request-changes-header-actions" style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <button type="button" onClick={onCancel} style={headerButtonStyle}>
              {actionLabel}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
